import { Info, Loader2 } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { getCrewStatusText } from '@/helpers/enumStylers';
import { FormSelect } from '@/components/shared/FormSelect';
import { useCrews } from '@/hooks/api/useCrews';

interface DispatchOptionsProps {
  autoDispatch: boolean;
  onAutoDispatchChange: (checked: boolean) => void;
}

export function DispatchOptions({
  autoDispatch,
  onAutoDispatchChange,
}: DispatchOptionsProps) {
  const { crews, isLoading } = useCrews();

  return (
    <div className="pt-2 border-t">
      <h3 className="text-sm font-medium mb-3">Dispatch Options</h3>

      <div className="flex items-center space-x-2">
        <Switch
          id="auto-dispatch"
          checked={autoDispatch}
          onCheckedChange={onAutoDispatchChange}
        />
        <Label htmlFor="auto-dispatch" className="font-medium">
          Automatic Dispatch
        </Label>

        {/* <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info size={16} className="text-gray-500 ml-1 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>
              <p className="w-[200px] text-xs">
                When enabled, the system automatically assigns the best crew.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider> */}
      </div>

      {/* Manual crew selection shows when auto-dispatch is OFF */}
      {!autoDispatch && (
        <div className="space-y-2 mt-4">
          {isLoading ? (
            <div className="flex items-center text-sm text-gray-500">
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Loading available crews...
            </div>
          ) : (
            <FormSelect
              name="crewId"
              label="Select Crew"
              rules={{
                required: 'Please select a crew or enable automatic dispatch.',
              }}
              disabled={isLoading || (crews && crews.length === 0)}
              options={
                crews?.map((crew) => ({
                  value: crew.id,
                  label: `${crew.name} | ${getCrewStatusText(
                    crew.operationalStatus,
                  )}`,
                })) || []
              }
            />
          )}
        </div>
      )}
    </div>
  );
}
